// Routes owned by the Tenders module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const tendersPaths = {
    // Tenders
    tenders: '/tenders',
    tenderDetail: '/tenders/:tenderId',
    tenderBidResult: '/tenders/:tenderID/bid-result',
} as const
